import * as React from 'react';
// mui
import {
  Box,
  Skeleton,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const LENGTH = 10;

export default function UpcomingListSkeleton() {
  const renderSkeletonTasks = (): React.ReactNode => {

    return Array.from({ length: LENGTH }).map((_, index) => (
      <Box key={index}>
        <ListItem>
          <ListItemText
            primary={<Skeleton width="60%" />}
            secondary={
              <Skeleton width="80%" height={20} />
            }
          />
          <Skeleton variant="circular" width={24} height={24} sx={{ marginRight: 1 }} />
          <Skeleton variant="circular" width={24} height={24} />
        </ListItem>
      </Box>
    ));
  };

  return (
    <List disablePadding>
      {renderSkeletonTasks()}
    </List>
  );
}
